import { render, staticRenderFns } from "./EditModelContract.vue?vue&type=template&id=7f0fa746&"
import script from "./EditModelContract.vue?vue&type=script&lang=js&"
export * from "./EditModelContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports